import { http, prepareHttpQuery } from 'http';

export default {
  getMasterData: () => http.get('/flex/vhstoragemgmt/masterdata'),

  getCarList: filterData => {
    const baseUrl = `/flex/vhstoragemgmt/list`;
    const queries = prepareHttpQuery(filterData);
    return http.get(`${baseUrl}${queries}`);
  },

  getTasks: filterData => {
    const baseUrl = `/flex/vhstoragemgmt/tasks`;
    const queries = prepareHttpQuery(filterData);
    return http.get(`${baseUrl}${queries}`);
  },

  getAccessories: plate => http.get(`/flex/vhstoragemgmt/vhaccessories/${plate}`),

  getCarDetail: plate => http.get(`/flex/vhstoragemgmt/vhdetails/${plate}`),

  getPaps: filterData => {
    const baseUrl = `/flex/vhstoragemgmt/paps`;
    const queries = prepareHttpQuery(filterData);
    return http.get(`${baseUrl}${queries}`);
  },

  getPapDetail: id => http.get(`/flex/vhstoragemgmt/papDetail/${id}`),

  getTransportationList: filterData => {
    const baseUrl = `/flex/transport/list`;
    const queries = prepareHttpQuery(filterData);
    return http.get(`${baseUrl}${queries}`);
  },

  getDiscrepancies: idTransport => http.get(`/flex/transport/discrepancies/${idTransport}`)
};
